import React, { useRef, useLayoutEffect } from "react";
import { ArrowRight } from "lucide-react";
import TrackedButton from "./TrackedButton";
import heroVideo from "../assets/images/herovideo1.mp4";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function HeroSection({ isMenuOpen, toggleMenu }) {
  const sectionRef = useRef(null);
  const pinRef = useRef(null);
  const overlayRef = useRef(null);
  const contentRef = useRef(null);
  const scrollRevealRef = useRef(null);


useLayoutEffect(() => {
  const ctx = gsap.context(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top top",
        end: "80% top",
        scrub: true,
        pin: pinRef.current,
        pinSpacing: false,
        anticipatePin: 0.5,
      },
    });

    tl.to(overlayRef.current, {
      opacity: 0.9,
      ease: "none",
      duration: 1,
    }, 0)
    
    .fromTo(scrollRevealRef.current,
      { y: 100, opacity: 0 },
      { y: 0, opacity: 1, ease: "none", duration: 0.6 },
      0
    );
  }, sectionRef);

  return () => ctx.revert();
}, []);


  return (
    <section
      ref={sectionRef}
      id="hero"
      className="relative h-[200vh] w-full overflow-hidden bg-black"
    >
      <div
        ref={pinRef}
        className="sticky top-0 h-screen w-full overflow-hidden"
      >
        {/* Background Video */}
        <video
          className="absolute inset-0 w-full h-full object-cover z-0 will-change-transform"
          src={heroVideo}
          autoPlay
          loop
          muted
          playsInline
        />

        {/* Dark Overlay */}
        <div
        ref={overlayRef}
        className="absolute inset-0 bg-black/40 pointer-events-none"
      />

        {/* Logo */}
        <div className="absolute top-10 left-8 z-20 hidden md:flex">
          <img
            src="/assets/images/strobelogo.svg"
            alt="Strobe Logo"
            className="w-52 h-auto"
          />
        </div>

        {/* Hero Content */}
<div ref={contentRef} className="relative z-20 flex flex-col justify-end h-full">
  <div className="absolute left-8 bottom-10 md:bottom-24">
    <div className="relative pl-6 md:pl-8 max-w-xl text-white">
  {/* Vertical line should live here so it’s visible from load */}
  <div className="absolute left-0 top-0 h-full w-[2px] bg-white/30" />

  {/* Always-visible headline */}
  <h1 className="text-4xl md:text-6xl font-heading font-semibold tracking-normal">
    One Brand
  </h1>
  <h1 className="text-4xl md:text-6xl font-heading font-semibold tracking-normal">
    Two Specialties
  </h1>

  {/*  Scroll-revealed content only */}
  <div ref={scrollRevealRef}>
    <p className="text-xl md:text-2xl font-body mt-2 tracking-tight">
      Aviation photography + ferry services.
    </p>
    <p className="text-xl md:text-2xl font-body mt-2 tracking-tight">
      Built by a pilot. Trusted by the pros.
    </p>

    <TrackedButton
      to="/about"
      label="Discover"
      eventLabel="Hero Discover Click"
      className="mt-8 inline-flex items-center justify-between gap-3 px-8 py-4 h-20 rounded-full bg-white/10 hover:bg-white/20 text-white font-body font-semibold tracking-tight backdrop-blur-md transition duration-300 border border-white/30 text-lg"
    >
      <span>Discover</span>
      <ArrowRight className="w-6 h-6 stroke-[1.5]" />
    </TrackedButton>
  </div>
</div>
  </div>
</div>
</div>
    </section>
  );
}
